/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import * as React from 'react';
import { AbstractWizardState } from './AbstractWizardState';
import {
  ISiteDetails
} from '../../stores/GatewayManager/IGatewayRegistrationInterfaces';
import { RegistrationProcessState } from './RegistrationProcessState';
import { LaunchDIYGatewayManagement } from '../wizard/GatewayRegistration/LaunchDIYGatewayManagement';
import featureFlagStore from '../../utils/FeatureFlags/APFeatureFlagsStore';
/**
 * This models the site selection stage of gateway management.
 * This is the entry point in to the application and returns a JSX element
 * corresponding to `SiteSelection`
 */
export class SiteSelectionState extends AbstractWizardState {

  /**
   * Get the content corresponding to the site selection
   * @returns {JSX.Element}
   */
  getContent(): JSX.Element {
    let state = this.page.state;
    return <LaunchDIYGatewayManagement
      serialNumber={state.serialNumber}
      conditions={this.getConditions()}
      siteSelected={(siteDetails: ISiteDetails): void => {
        this.siteSelected(siteDetails);
      }} />;
  }

  /**
   * The callback once site is selected.
   * Initiates the gateway registration
   */
  siteSelected = (siteDetails: ISiteDetails) => {
    this.page.setState({
      selectedSite: siteDetails,
      registrationStatus: new RegistrationProcessState(this.page)
    });
  };

  getConditions = () => {
    return [{
      execute() {
        return Promise.resolve(featureFlagStore.getGatewayRegistrationEnabled);
      }
    }]
  };

}
